import { Input, Tooltip } from 'antd'
import classNames from 'classnames'
import styles from './InputArea.module.css'
import { getAIPrompt_pictureGraph_aiCreateArtworkOptionMenu_promptTipsOptions } from '~/graphqls/types'
import { MyIcon } from '~/components/ui/MyIcon'
import { MyCheckbox } from '~/components/ui/MyCheckbox'
import { omit } from 'lodash'
import { useEffect } from 'react'

interface Props {
  prompts?: getAIPrompt_pictureGraph_aiCreateArtworkOptionMenu_promptTipsOptions[]
  value?: string
  onChange?: any
  onRefresh?: () => void
  /** antd 会注入一些东西 */
  [key: string]: any
  promptOptimize?: boolean
  setPromptOptimize?: (arg: boolean) => void
  showSuggest?: boolean
  placeholder?: string
  maxLength?: number
  autoBottom?: boolean
}

export default function InputArea({
  value,
  onChange,
  prompts,
  onRefresh,
  promptOptimize,
  setPromptOptimize,
  showSuggest = true,
  placeholder,
  maxLength = 1000,
  autoBottom,
  ...other
}: Props) {
  const handleSuggestionClick = (text: string) => {
    onChange?.(text.slice(0, maxLength))
  }

  const handleClear = () => {
    onChange?.('')
  }

  useEffect(() => {
    if (autoBottom) {
      let scrollItem = document.getElementById('autoBottom')
      scrollItem!.scrollTop = scrollItem!.scrollHeight
    }
  }, [autoBottom])

  return (
    <div
      className={classNames(
        styles.inputArea,
        {
          [styles.inputAreaWithoutSuggest]: !showSuggest,
        },
        other?.className
      )}
      {...omit(other, 'className')}
    >
      <Input.TextArea
        maxLength={maxLength}
        autoSize={{ minRows: 3 }}
        showCount
        placeholder={placeholder}
        value={value?.slice(0, maxLength)}
        onChange={onChange}
        id="autoBottom"
      ></Input.TextArea>

      {showSuggest && (
        <div className="flex items-center justify-between gap-2 text-neutral-500 text-xs mt-2 whitespace-nowrap overflow-hidden text-ellipsis">
          <div className="flex items-center gap-2 whitespace-nowrap overflow-hidden text-ellipsis">
            示范：
            {prompts?.map(item => {
              return (
                <a
                  className="whitespace-nowrap overflow-hidden text-ellipsis"
                  key={item.name}
                  onClick={() => handleSuggestionClick(item.name!)}
                >
                  {item.name}
                </a>
              )
            })}
          </div>

          <div
            className="flex items-center cursor-pointer"
            onClick={() => onRefresh?.()}
          >
            <MyIcon icon="refresh" className="text-[12px]" />
          </div>
        </div>
      )}

      <div
        className={classNames(
          'flex items-center text-neutral-800 text-xs',
          styles.clearBtn
        )}
      >
        <div className="h-4 w-px bg-neutral-300 mr-4"></div>
        <div className="flex items-center cursor-pointer" onClick={handleClear}>
          清空
        </div>
      </div>

      {/* <div className="absolute bottom-[47px] left-4 flex items-center">
        <MyCheckbox
          $dark={true}
          checked={promptOptimize}
          onChange={e => setPromptOptimize(e.target.checked)}
        >
          <span className="text-xs flex items-center text-neutral-800 select-none">
            智能优化
          </span>
        </MyCheckbox>
        <span className="text-neutral-800 text-[16px] leading-none -ml-1">
          <Tooltip title="智能优化适合小白新手用户，建议仅在输入简短词汇时使用，此功能可根据你输入的画面描述生成更具有艺术修饰效果的作品">
            <MyIcon icon="info-circle" />
          </Tooltip>
        </span>
      </div> */}
    </div>
  )
}
